import React from "react";
import { useField } from "formik";
import { TransactionRuleActionFormSchema } from "../constants";
import { AccountSelect } from "../../../../accounts/AccountSelect";
import { useAccounts } from "../../../../../hooks/useAccounts";
import { useEntitiesFromFormCondition } from "../useEntitiesFromFormCondition";

interface Props {
    index: number;
}

export const AccountActionForm: React.FC<Props> = ({ index }) => {
    const [field, , helpers] = useField<
        TransactionRuleActionFormSchema["accountValue"]
    >(`actions.${index}.accountValue`);

    const entities = useEntitiesFromFormCondition();

    const { accounts, isLoading } = useAccounts({
        entityId: !entities[0].isPersonal ? entities[0]?.id : undefined,
        excludeLinkedToFinancialAccount: true,
    });

    if (isLoading) {
        return null;
    }

    const selectedAccount = accounts.find(({ id }) => id === field.value);

    if (field.value && !selectedAccount) {
        helpers.setValue(undefined);
    }

    if (!entities || entities.length !== 1) {
        return <span>Select a single entity</span>;
    }

    if (entities[0].isPersonal) {
        return (
            <span>
                Personal entities are not supported for Account assignment
            </span>
        );
    }

    return (
        <AccountSelect
            selectedAccount={selectedAccount}
            onChange={(account) => helpers.setValue(account?.id)}
            dropdownKey={`transaction_account_${index}`}
            entityId={entities[0].id}
            size="xs"
        />
    );
};
